import { PayloadAction } from '@reduxjs/toolkit';
import { UpsellState } from 'src/store/upsell/types';

const setIncludeRemoveLogoReducer = (
  state: UpsellState, action: PayloadAction<boolean>,
) => {
  state.includeRemoveLogo = action.payload;
};

export default setIncludeRemoveLogoReducer;
